import { useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { API_URL } from '../../../Constants';
import Loader from '../Loader/Loader';
import NoDataComponent from '../Custom/NoDataComponent/NoDataComponent';

function PDFCalendar({
  type,
  year,
  isSuccesCalendarPoster,
  onPosterStateChange,
}) {
  const [iframeSrc, setIframeSrc] = useState(null);
  const objectUrlRef = useRef(null);

  const fetchPdfPoster = async () => {
    const fileUrl =
      API_URL + `/api/Calendar/GetCaledarPosterByTypeandYear/${type}/${year}`;

    const linkUrl =
      API_URL + `/api/Calendar/GetCalendarPosterURL/${type}/${year}`;

    const fetchPosterLink = async () => {
      const res = await fetch(linkUrl, {
        headers: {
          Accept: 'application/json, text/plain',
        },
      });

      if (res.status === 204 || res.status === 404) return null;

      if (!res.ok) return null;

      const contentType = (res.headers.get('content-type') || '').toLowerCase();

      if (contentType.includes('application/json')) {
        const json = await res.json();

        if (json?.bloburl && json?.posterURL) {
          return `${json.bloburl}${json.posterURL}`;
        }
      }

      const text = await res.text();
      return text || null;
    };

    try {
      const res = await fetch(fileUrl, {
        headers: {
          Accept: 'application/pdf',
        },
      });

      if (res.ok) {
        const contentType = (
          res.headers.get('content-type') || ''
        ).toLowerCase();
        const blob = await res.blob();

        const isPdf =
          contentType.includes('application/pdf') ||
          (blob.type || '').toLowerCase().includes('pdf');

        if (blob && blob.size > 0 && isPdf) {
          onPosterStateChange?.(true);
          return blob;
        }
      }
    } catch (error) {
      console.error('PDF API failed, trying poster URL API:', error);
    }

    const posterLink = await fetchPosterLink();

    if (!posterLink) {
      onPosterStateChange?.(false);
      return null;
    }

    onPosterStateChange?.(true);

    if (posterLink.startsWith('http')) {
      return posterLink;
    }

    if (posterLink.startsWith('/')) {
      return `${API_URL}${posterLink}`;
    }

    return posterLink;
  };

  const enabled = type != null && year != null;

  const { data, isLoading, isFetching, isError, refetch } = useQuery(
    ['pdfPoster', type, year],
    fetchPdfPoster,
    {
      enabled,
      retry: false,
      refetchOnWindowFocus: false,
    },
  );

  useEffect(() => {
    setIframeSrc(null);
    if (objectUrlRef.current) {
      URL.revokeObjectURL(objectUrlRef.current);
      objectUrlRef.current = null;
    }
  }, [type, year]);

  useEffect(() => {
    if (!data) {
      setIframeSrc(null);
      return;
    }

    if (typeof data === 'string') {
      setIframeSrc(data);
      return;
    }

    const objectUrl = URL.createObjectURL(data);
    objectUrlRef.current = objectUrl;
    setIframeSrc(objectUrl);

    return () => {
      if (objectUrlRef.current) {
        URL.revokeObjectURL(objectUrlRef.current);
        objectUrlRef.current = null;
      }
    };
  }, [data]);

  useEffect(() => {
    if (isSuccesCalendarPoster) refetch();
  }, [isSuccesCalendarPoster, refetch]);

  if (!enabled) return <NoDataComponent text='لم يتم رفع أي ملصق' />;

  if (isLoading || isFetching) return <Loader />;

  if (isError) return <NoDataComponent text='لم يتم رفع أي ملصق' />;

  // no poster
  if (!data || !iframeSrc) return <NoDataComponent text='لم يتم رفع أي ملصق' />;

  return <iframe src={iframeSrc} width='100%' height='500px' />;
}

export default PDFCalendar;
